/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Spaces_Items_MovedInputs */



/**
* | output |
* | --- |
* | "Moved {count} item(s)" |
*
* @param {Spaces_Items_MovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_items_moved = /** @type {((inputs: Spaces_Items_MovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Items_MovedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Element(e) verschoben`)
	return /** @type {LocalizedString} */ (`Moved ${i?.count} item(s)`)
});